import { render, staticRenderFns } from "./CardTechSpecs.vue?vue&type=template&id=6b5aa866&scoped=true&"
import script from "./CardTechSpecs.vue?vue&type=script&lang=js&"
export * from "./CardTechSpecs.vue?vue&type=script&lang=js&"
import style0 from "./CardTechSpecs.vue?vue&type=style&index=0&id=6b5aa866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5aa866",
  null
  
)

export default component.exports